var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.41 9.254.063.01q.006 0 .012.002.133.028.243.097l.023.014q.062.04.114.093l2.666 2.667.051.056a.75.75 0 0 1-1.054 1.055l-.058-.05-1.386-1.386V15a.75.75 0 0 1-1.5 0v-3.19l-1.386 1.387a.75.75 0 0 1-1.061-1.06L7.804 9.47a.8.8 0 0 1 .22-.153q.024-.01.049-.018.045-.016.09-.028l.041-.01.035-.005a1 1 0 0 1 .095-.006zM8.334.25a.75.75 0 0 1 .75.75v3.521l1.386-1.385.058-.051a.75.75 0 0 1 1.054 1.055l-.051.056-2.666 2.667a.75.75 0 0 1-.947.094l-.114-.094-2.667-2.667a.75.75 0 0 1 1.06-1.06l1.387 1.386V1a.75.75 0 0 1 .75-.75"
  })));
};
export default Svg16;